
// @ts-ignore
import TrackeData from '@/utils/trackData';
import { Component, Vue, Prop } from 'vue-property-decorator';

const NEWBK: number = 4; // 新版备授课

@Component
export default class BeikeBtn extends Vue {
[x: string]: any;

  // 机构签约状态
  @Prop(Number) signed!: number

  // 公测账号
  @Prop(Number) example!: number

  @Prop() lessonInfo!: any

  @Prop() currentClass!: any

  @Prop() currentTime!: number // 弹窗打开的时间

  @Prop() isdtAssistant!: boolean

  // 是否签约(未签约大于3讲|| 演示账号大于5 置灰处理)
  get unSigned(): boolean | 0 {
    return (!this.signed && this.lessonInfo.lessonNum > 3)
      || (this.example && this.lessonInfo.lessonNum > 5);
  }

  // 点击埋点
  private clickTrack(action: string, params: any) {
    this.$track.sendClickLog(TrackeData[action], params);
  }

  // 处理备课
  private handleBeike() {
    let href: string = '';
    const {
      lessonName,
      lessonNum,
      lessonId,
      classTypeTypeId,
      subjectId,
      lectureRelationship,
      jumpLesson, // 跳课标示
      outClass, // 是否退班
      outLessonNum, // 退班后是否可备课
    } = this.lessonInfo;
    const {
      classTypeId,
      name,
      style,
      businessId,
      type,
      newDiyFlag, // 新老diy 0老diy   1新diy
    } = this.currentClass;

    // 备课埋点
    setTimeout(() => {
      this.clickTrack('PRELESSONS_PREPARATION_CLICK', {
        id: classTypeId, name, lessonName, lessonNum,
      });
    }, 200);

    // 双师/AI小班退班助教权益
    if (outClass && this.isdtAssistant && outLessonNum) {
      this.$toast.show('小班已退班，您无备课权限');
      return false;
    }
    // 跳课提示
    if (jumpLesson === 1) {
      this.$toast.show('该讲次已跳课，您无备课权限');
      return false;
    }
    if (style === NEWBK) {
      href = `${process.env.VUE_APP_JUMPURL}/courseInfo.html#/?
      lessonId=${lessonId}&
      classTypeId=${classTypeTypeId}&
      subjectId=${subjectId}&
      businessId=${businessId}&
      businessType=${type}&
      lectureRelationship=${lectureRelationship}&
      newDiyFlag=${newDiyFlag}`;
    } else {
      href = `//bk.aixuexi.com/#/index/courseInfo?
      lessonId=${lessonId}&
      classTypeId=${classTypeTypeId}&
      subjectId=${subjectId}&
      styleClass=${style}&
      classId=${businessId}&
      newDiyFlag=${newDiyFlag}`;
    }
    // 保存选择讲次
    this.saveHistory();
    //  埋点首次点击发送弹窗时长
    if (this.currentTime) {
      const clickTime: number = Date.now();
      const durationTime: number = clickTime - this.currentTime;
      this.$utils.sendAction('index', 'index', 'id-12', {
        durationTime,
      });
      this.$emit('updateCurrentTime');
    }
    // 备课埋点
    // 区分兼容课程搜索和正常点击的备课点击来源
    const param = this.$route.query.searchPage ? {
      searchPage: true,
      searchBackPath: this.$route.query.backPath,
      searchText: this.$route.query.value,
      searchTextId: this.$route.query.id,
      businessId: this.currentClass.businessId,
      lessonId: this.lessonInfo.lessonId,
    } : {};
    this.$utils.sendAction('index', 'index', 'id-1', param);
    // 备课跳转
    window.open(this.$utils.trimAll(href), '_blank');
    return true;
  }

  private saveHistory() {
    const data = {
      type: this.currentClass.type,
      businessId: this.currentClass.businessId,
      lessonId: this.lessonInfo.lessonId,
    };
    this.$service.bk.saveHistory(data);
  }
}
